var CardRowMixin = {
  name: 'CardRowMixin',
  data: function () {
    return {
      tempNo: -1,
      interval: null
    }
  },
  methods: {
    setParentClass: function (parentClass) {
      this.parentClass = parentClass
    },
    setHoverNo: function (hoverNo) {
      this.tempNo = hoverNo
      if (this.touchDevice) {
        this.changeHoverNo()
      }
    },
    changeHoverNo: function () {
      this.hoverNo = this.tempNo
    },
    startInterval: function () {
      var self = this
      self.interval = setInterval(function () {
        self.changeHoverNo()
      }, 400)
    },
    clearInterval: function () {
      var self = this
      clearInterval(self.interval)
      this.changeHoverNo()
    }
  },
  watch: {
    userActive: function () {
      if (this.userActive) {
        this.startInterval()
      } else if (!this.userActive) {
        this.clearInterval()
      }
    }
  }
}

export default CardRowMixin



// WEBPACK FOOTER //
// ./src/containers/mixins/CardRowMixin.js